<template>
  <v-container fluid>
    <router-view></router-view>

    <crawler-inspection-details-dialog></crawler-inspection-details-dialog>
  </v-container>
</template>

<script>
import CrawlerInspectionDetailsDialog from '@/views/Pages/Admin/Dialogs/CrawlerInspectionDetailsDialog'

export default {
  name: 'AdminPage',
  components: { CrawlerInspectionDetailsDialog }
}
</script>